import { useEffect, useState } from 'react';
import { C, FONTS } from '../../tokens/design';
import Button from './Button';

export default function LiveActionButton({
  children,
  onConfirm,
  confirmTitle = 'Confirm live action',
  confirmDetail,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  disabled = false,
  pending = false,
  pendingLabel = 'Working...',
  variant = 'sec',
  style = {},
}) {
  const [armed, setArmed] = useState(false);

  useEffect(() => {
    if (disabled || pending) setArmed(false);
  }, [disabled, pending]);

  if (!armed) {
    return (
      <Button
        variant={variant}
        onClick={() => setArmed(true)}
        disabled={disabled || pending}
        style={style}
      >
        {pending ? pendingLabel : children}
      </Button>
    );
  }

  return (
    <span style={{ display: 'inline-flex', alignItems: 'stretch', gap: 6, flexWrap: 'wrap', maxWidth: 360 }}>
      <span style={{
        display: 'inline-flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 2,
        padding: '6px 8px',
        borderRadius: 6,
        background: `${C.amb}12`,
        border: `1px solid ${C.amb}44`,
        minWidth: 180,
      }}>
        <span style={{ fontSize: 10, color: C.amb, fontWeight: 800, fontFamily: FONTS.sans }}>
          {confirmTitle}
        </span>
        {confirmDetail && (
          <span style={{ fontSize: 9, color: C.t2, fontFamily: FONTS.mono, lineHeight: 1.35 }}>
            {confirmDetail}
          </span>
        )}
      </span>
      <Button
        variant="pri"
        onClick={() => {
          setArmed(false);
          onConfirm?.();
        }}
        disabled={disabled || pending}
        style={style}
      >
        {confirmLabel}
      </Button>
      <Button
        variant="sec"
        onClick={() => setArmed(false)}
        disabled={pending}
        style={style}
      >
        {cancelLabel}
      </Button>
    </span>
  );
}
